import React from 'react';

const Dashboard = () => {
    return (
        <div>
            <h1 className="text-3xl font-bold mb-4">Dashboard</h1>
            <p className="text-gray-600">Welcome to the SNCAI Content Management System.</p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
                <div className="p-6 bg-white rounded shadow">
                    <h3 className="text-lg font-semibold mb-2">Instructions</h3>
                    <p className="text-gray-500">Select a section from the sidebar to edit content. All changes are live immediately upon saving.</p>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
